import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { serviceAreaTowns } from '../data/site';
export function ServiceAreaSection({
  showAction = true
}: {
  showAction?: boolean;
}) {
  return <section id="service-area" aria-labelledby="service-area-title" className="section-y border-t border-charcoal/10 bg-stone/60" data-id="element-231" data-mp="1rh8lohbo9g27">
      <div className="site-container grid gap-9 lg:grid-cols-12 lg:gap-16" data-id="element-232" data-mp="1wfiisxgyiqqg">
        <div className="lg:col-span-5" data-id="element-233" data-mp="zrcj8oyw6oj1">
          <p className="eyebrow text-moss" data-id="element-234" data-mp="zsdvuxvk3j2v">Our service area</p>
          <h2 id="service-area-title" className="mt-4 font-display text-[36px] font-medium leading-[1.1] text-charcoal sm:text-[42px] lg:text-[48px]" data-id="element-235" data-mp="13t7hfklj0lsl">
            Serving southeast Michigan.
          </h2>
          <p className="mt-5 max-w-[440px] text-[16px] leading-relaxed text-charcoal/75" data-id="element-236" data-mp="1drdk44f5pvyi">
            Based in Livonia, we provide landscape and property-care services in these communities and surrounding areas.
          </p>
          {showAction ? <a href="/#contact" className="focus-ring group mt-6 inline-flex min-h-[44px] items-center gap-3 text-[15px] font-medium text-olive" data-id="element-237" data-mp="1ah3vea0uwuex">
              <span className="border-b border-olive/35 pb-0.5 transition-colors group-hover:border-olive" data-id="element-238" data-mp="16gtsx7c9wm4t">Ask about service in your area</span>
              <ArrowRightIcon className="h-4 w-4 shrink-0" strokeWidth={1.5} aria-hidden="true" data-id="element-239" data-mp="11i8rx5p75yfb" />
            </a> : null}
        </div>
        <div className="lg:col-span-7 lg:self-center" data-id="element-240" data-mp="rj9r29aob72v">
          <ul aria-label="Communities we serve" className="grid grid-cols-2 gap-x-6 sm:gap-x-10" data-id="element-241" data-mp="rk2nagc0ae6r">
            {serviceAreaTowns.map(town => <li key={town} className="border-b border-charcoal/15 py-4 text-[16px] leading-relaxed text-charcoal" data-id="element-242" data-mp="iqzfank4qtji">
                {town}
              </li>)}
          </ul>
          <p className="mt-5 text-[14px] leading-relaxed text-charcoal/65" data-id="element-243" data-mp="8s07163a0zx1">
            Contact us to discuss the services available for your property.
          </p>
        </div>
      </div>
    </section>;
}